<template>
  <div class="h-100 d-flex flex-column">
    <!-- https://www.primefaces.org/primevue/showcase-v2/#/datatable -->
    <div class="row f-row h-100 justify-content-center">
      <div
        class="col col-12 text-center justify-content-center"
        style="width:100%; padding: 0 5px 0 5px;
        height: calc(100vh - 128px)!important;"
      >
        <DataTable
          :alwaysShowPaginator="true"
          :filters.sync="filters"
          :loading="showLoading"
          :paginator="true"
          :rowHover="true"
          :rows="15"
          :rowsPerPageOptions="[10, 15, 20, 25, 30, 50, 100, 1000]"
          :scrollable="true"
          :selection.sync="selectedHedges"
          :value="dataVar"
          :virtual="true"
          ref="dt"
          class="p-datatable-sm editable-cells-table"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
          editMode="cell"
          :filterDisplay="showFilters ? 'menu' : ''"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          responsiveLayout="scroll"
          stickyHeader="true"
        >
          <!-- @cell-edit-complete="onCellEditComplete"-->
          <template #header>
            <div
              class="flex justify-content-between align-items-center"
              style="background: var(--lightbackground3)!important;"
            >
              <table
                class="table table-sm table-borderless"
                style="padding: 0 5px 0 5px;"
              >
                <tbody>
                  <tr>
                    <td style="width: 10%" class="txt-label-primary">
                      <span class="p-input-icon-left">
                        <i
                          class="pi pi-search"
                          style="font-size: 0.75rem!important;"
                        />
                        <InputText
                          style="font-size: 0.75rem!important;"
                          v-model="filters['global'].value"
                          placeholder="Keyword Search"
                        />
                      </span>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%;"
                    >
                      <ToggleButton
                        :id="'fields'"
                        :defaultState="false"
                        :labelEnableText="'- Fields'"
                        :labelDisableText="'+ Fields'"
                        v-on:change="showAllFields = !showAllFields"
                      />
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      Download:
                      <button
                        v-on:click="download"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary"
                      >
                        <i class="fa fa-download" aria-hidden="true"></i>
                      </button>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      Add:
                      <button
                        v-on:click="onClientCreate"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary"
                      >
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </button>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      {{ saveLegend }}
                      <button
                        v-on:click="onClientSaveToDB"
                        v-if="!dataSaved"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary btn-warn"
                      >
                        <i class="fa fa-save" aria-hidden="true"></i>
                      </button>
                      <i class="fa fa-check" aria-hidden="true" v-else></i>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      {{ refreshLegend }}
                      <button
                        v-on:click="onClientDiscard"
                        v-if="!dataSaved"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary btn-warn"
                      >
                        <i class="fa fa-refresh" aria-hidden="true"></i>
                      </button>
                      <i class="fa fa-check" aria-hidden="true" v-else></i>
                    </td>
                    <td
                      class="txt-label-primary text-center"
                      style="width: 10%"
                    >
                      Delete:
                      <button
                        v-on:click="deleteFromDB"
                        type="submit"
                        class="btn-up-dn-load txt-label-primary"
                      >
                        <i class="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
          <template #empty>
            No hedges found.
          </template>
          <template #loading>
            Loading hedges. Please wait.
          </template>

          <Column
            field="actions"
            header="Actions"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              <i
                class="fa fa-exclamation program"
                aria-hidden="true"
                v-show="data.edited"
              ></i>
              <button
                v-on:click="onEditItem(data)"
                type="submit"
                class="btn-edit-delete"
              >
                <i class="fa fa-pencil" aria-hidden="true"></i>
              </button>
              <button
                v-on:click="onCopyItem(data)"
                type="submit"
                class="btn-edit-delete"
              >
                <i class="fa fa-copy" aria-hidden="true"></i>
              </button>
              <button
                v-on:click="onDeleteItem(data)"
                type="submit"
                class="btn-edit-delete"
              >
                <i class="fa fa-trash" aria-hidden="true"></i>
              </button>
            </template>
          </Column>

          <Column
            field="custom_id"
            header="ID"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.custom_id }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by id"
              />
            </template>
          </Column>

          <Column
            field="exposure_id"
            header="Exposure ID"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.exposure_id }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by exposure id"
              />
            </template>
          </Column>

          <Column
            header="Hedged Date"
            field="hedged_date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.hedged_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            header="Product"
            sortable
            filterField="fk_id_end_product"
            sortField="fk_id_end_product"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.fk_id_end_product }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Product Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="productDDown"
                placeholder="Select Product"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Portfolio"
            sortable
            filterField="fk_idportfolio"
            sortField="fk_idportfolio"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idportfolio }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Portfolio Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="portfoliosDDown"
                placeholder="Select Portfolios"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Commodity"
            sortable
            filterField="fk_idcommodity"
            sortField="fk_idcommodity"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idcommodity }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Comdty Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="commoditiesDDown"
                placeholder="Select commodity"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Long | Short"
            sortable
            filterField="buy_sell"
            sortField="buy_sell"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.buy_sell }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Position Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="['LONG', 'SHORT', 'OFFSET LONG', 'OFFSET SHORT']"
                placeholder="Select Position"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Derivative"
            sortable
            filterField="derivative"
            sortField="derivative"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              <img
                :alt="data.derivative"
                :src="data.dImg"
                width="12"
                style="vertical-align: middle"
              />
              <span class="image-text">&nbsp;{{ data.derivative }}</span>
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Derivative Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="['FUTURE', 'FORWARD', 'CALL', 'PUT']"
                placeholder="Select Derivative"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Derivative Type"
            sortable
            filterField="fk_idoptiontype"
            sortField="fk_idoptiontype"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '8rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idoptiontype }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Type Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="optionTypes"
                optionLabel="name"
                optionValue="name"
                placeholder="Select Type"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option.name }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            header="Settlement Type"
            sortable
            filterField="settlement_type"
            sortField="settlement_type"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '9rem' }"
            :styles="{ 'min-width': '9rem' }"
          >
            <template #body="{data}">
              {{ data.settlement_type }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Type Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="['DELIVERABLE', 'NON DELIVERABLE']"
                placeholder="Select Type"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            field="trade_date"
            header="Trade Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.trade_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            header="Fixing Date"
            field="fixing_date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.fixing_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            header="Value Date"
            field="value_date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.value_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            header="Strike"
            field="strike"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.strike | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            field="quantity"
            header="Quantity"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.quantity | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            header="Premium"
            field="premium"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '6rem' }"
          >
            <template #body="{data}">
              {{ data.premium | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            header="Premium Date"
            field="premium_value_date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.premium_value_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            field="contract_month_year"
            header="Futures Date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.contract_month_year | futuresDateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            field="continuation_month"
            header="Continuation month"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '10rem' }"
          >
            <template #body="{data}">
              {{ data.continuation_month | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            header="Barrier"
            field="barrier"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.barrier | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            header="Second Barrier"
            field="barrier_2"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.barrier_2 | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            header="Asian Initial Date"
            field="asian_fixing_start_date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.asian_fixing_start_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Strategy"
            sortable
            filterField="fk_idcommodity_strategy"
            sortField="fk_idcommodity_strategy"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '10rem' }"
          >
            <template #body="{data}">
              {{ data.fk_idcommodity_strategy }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Strategy Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="strategiesDDown"
                placeholder="Select Strategy"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Strategy Code"
            field="strategy_code"
            sortable
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.strategy_code }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by code"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Spot Reference"
            field="spot_reference"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '5rem' }"
          >
            <template #body="{data}">
              {{ data.spot_reference | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="custom_strategy_name"
            header="Custom Strategy Name"
            sortable
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.custom_strategy_name }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by strategy name"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Counterparty"
            sortable
            filterField="counterparty"
            sortField="counterparty"
            :showFilterMatchModes="false"
            :filterMenuStyle="{ width: '14rem' }"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.counterparty }}
            </template>
            <template #filter="{filterModel}">
              <div class="mb-3 font-bold">Portfolio Picker</div>
              <MultiSelect
                v-model="filterModel.value"
                :options="counterPDDown"
                placeholder="Select Counterparty"
                class="p-column-filter"
                scrollHeight="400px"
              >
                <template #option="slotProps">
                  <div class="p-multiselect-representative-option">
                    <span class="image-text">{{ slotProps.option }}</span>
                  </div>
                </template>
              </MultiSelect>
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="comments"
            header="Comments"
            sortable
            :styles="{ 'min-width': '10rem' }"
          >
            <template #body="{data}">
              {{ data.comments }}
            </template>
            <template #filter="{filterModel}">
              <InputText
                type="text"
                v-model="filterModel.value"
                class="p-column-filter"
                placeholder="Search by comments"
              />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            field="settlement_rate"
            header="Settlement Price"
            sortable
            dataType="numeric"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.settlement_rate | numberFormat }}
            </template>
            <template #filter="{filterModel}">
              <InputNumber v-model="filterModel.value" />
            </template>
          </Column>

          <Column
            v-if="showAllFields"
            header="Settlement Date"
            field="fixing_date"
            sortable
            dataType="date"
            :styles="{ 'min-width': '8rem' }"
          >
            <template #body="{data}">
              {{ data.fixing_date | dateFormat }}
            </template>
            <template #filter="{filterModel}">
              <Calendar
                v-model="filterModel.value"
                dateFormat="mm/dd/yy"
                placeholder="mm/dd/yyyy"
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>

    <!-- Loading Modal -->
    <Messages :modal_message="modal_processing_message" />
    <Messages :modal_message="modal_process_finished_message" />
  </div>
</template>

<script>
import { gatewayService } from "@/_services/gateway.service";
import { Company } from "@/_core/data/Company";
import { derivativeImage } from "@/_core/charts/D3ChartAnalyticsChartHelpers";
import { FilterMatchMode, FilterOperator } from "primevue/api/";
import { SheetsTransaction } from "@/_core/export/SheetsTransaction";
import { timeFormat, format } from "d3";
import Calendar from "primevue/calendar";
import Column from "primevue/column";
import DataTable from "primevue/datatable";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import Messages from "../modals/Messages.vue";
import MultiSelect from "primevue/multiselect";
import ToggleButton from "@/components/ToggleButton.vue";
import { createDataModelTable } from "@/_core/data/SaveToDB";

export default {
  name: "DataTableHedgeCommodities",
  components: {
    Calendar,
    Column,
    DataTable,
    InputNumber,
    InputText,
    Messages,
    MultiSelect,
    ToggleButton,
  },
  props: {
    dataSaved: { required: true },
    dataVar: { required: true },
    headersToExport: { required: true },
    list_file: { required: true },
    optionTypes: { required: true },
    processData: { required: true },
    refreshLegend: { required: true },
    saveLegend: { required: true },
    selectedCompany: { required: true },
    selectedList: { required: true },
    selectedNAsset: { required: true },
    selectedPortfolios: { required: true },
    showLoading: { required: true },
  },
  data() {
    return {
      companies: [],
      dataToExport: [],
      selection: "com_hedge",
      filters: {
        custom_id: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        exposure_id: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        fk_idportfolio: { value: null, matchMode: FilterMatchMode.IN },
        fk_idcommodity: { value: null, matchMode: FilterMatchMode.IN },
        buy_sell: { value: null, matchMode: FilterMatchMode.IN },
        derivative: { value: null, matchMode: FilterMatchMode.IN },
        fk_idoptiontype: { value: null, matchMode: FilterMatchMode.IN },
        settlement_type: { value: null, matchMode: FilterMatchMode.IN },
        trade_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        fixing_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        value_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        strike: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        quantity: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        premium: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        premium_value_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        contract_month_year: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        continuation_month: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        barrier: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        barrier_2: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        asian_fixing_start_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        fk_idcommodity_strategy: {
          value: null,
          matchMode: FilterMatchMode.IN,
        },
        strategy_code: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        spot_reference: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        hedged_date: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
        },
        fk_id_end_product: { value: null, matchMode: FilterMatchMode.IN },
        custom_strategy_name: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        counterparty: { value: null, matchMode: FilterMatchMode.IN },
        comments: {
          operator: FilterOperator.AND,
          constraints: [
            { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          ],
        },
        settlement_rate: {
          operator: FilterOperator.AND,
          constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
        },
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      modal_process_finished_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      modal_processing_message: {
        showModalLoading: false,
        messageModal: "",
        optionsModal: false,
      },
      selectedHedges: null,
      sheetTransaction: null,
      showFilters: true,
      showAllFields: false,
      showMore: "+ Fields",
      user: [],
      lFwd: require("@/assets/images/lFwd.svg"),
      sFwd: require("@/assets/images/sFwd.svg"),
      lCall: require("@/assets/images/lCall.svg"),
      sCall: require("@/assets/images/sCall.svg"),
      lPut: require("@/assets/images/lPut.svg"),
      sPut: require("@/assets/images/sPut.svg"),
    };
  },
  computed: {
    portfoliosDDown() {
      return this.dataVar
        .map((d) => d.fk_idportfolio)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    commoditiesDDown() {
      return this.dataVar
        .map((d) => d.fk_idcommodity)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    quotationDDown() {
      return this.dataVar
        .map((d) => d.quotation)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
    strategiesDDown() {
      return this.dataVar
        .map((d) => d.fk_idcommodity_strategy)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null);
    },
    productDDown() {
      return this.dataVar
        .map((d) => d.fk_id_end_product)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d);
    },
    counterPDDown() {
      return this.dataVar
        .map((d) => d.counterparty)
        .sort()
        .filter(this.processData.onlyUnique)
        .filter((d) => d != null && d !== "");
    },
  },
  watch: {
    dataVar(val) {
      if (val.length > 0) {
        this.fillImg();
      }
    },
  },
  created() {
    try {
      this.sheetTransaction = new SheetsTransaction(
        this.dataToExport,
        this.headersToExport,
      );
    } catch (error) {
      console.log(`Error Process Data ${error}`);
    }
    try {
      this.user = this.$store.state.user.all.items;
    } catch (error) {
      console.log(`Error user ${error}`);
    }
    try {
      this.companies = this.$store.state.companies.all.items;
      this.companyLen = this.companies.length;
    } catch (error) {
      console.log(`Error companies ${error}`);
    }
    try {
      this.processed_company = new Company(this);
    } catch (error) {
      console.log(`Error companies loader ${error}`);
    }
  },
  mounted() {
    if (this.dataVar.length > 0) {
      this.fillImg();
    }
  },
  methods: {
    fillImg() {
      let _this = this;
      this.dataVar.forEach(function(d) {
        d.dImg = derivativeImage(
          {
            derivative: d.derivative.toLowerCase(),
            buy_sell: d.buy_sell.toLowerCase(),
          },
          _this.lFwd,
          _this.sFwd,
          _this.lCall,
          _this.sCall,
          _this.lPut,
          _this.sPut,
        );
      });
    },
    // ====================== Emit variables ======================
    onClientCreate() {
      this.$emit("eventOnClientCreate");
    },
    onEditItem(item) {
      this.$emit("eventOnEditItem", item);
    },
    onDeleteItem(item) {
      this.$emit("eventOnDeleteItem", item);
    },
    onCopyItem(item) {
      this.$emit("eventOnCopyItem", item);
    },
    onClientSaveToDB() {
      this.$emit("eventOnClientSaveToDB");
    },
    onClientDiscard() {
      this.$emit("eventOnClientDiscard");
    },
    onAfterDelete() {
      this.$emit("eventOnAfterDelete");
    },
    onAfterDeleteCompany() {
      this.$emit("eventOnAfterDeleteCompany");
    },

    // ====================== DB related ======================
    deleteFromDB() {
      var r = confirm(
        "Are you sure you want to delete this table (exposure/hedges)?",
      );
      if (r === true) {
        let deleteTable = null;
        let getPortfolioNumber = [];
        let vis = this;
        this.companies = this.$store.state.companies.all.items;
        vis.selectedPortfolios.forEach(function(selectedPortfolio) {
          getPortfolioNumber.push(
            vis.companies[vis.selectedCompany].portfolios[selectedPortfolio.id]
              .pk_idportfolio,
          );
        });
        if (this.selectedList === 0 && this.selectedNAsset === 0) {
          deleteTable = gatewayService.currencies.deleteExposure;
        }
        if (this.selectedList === 0 && this.selectedNAsset === 1) {
          deleteTable = gatewayService.commodities.deleteExposure;
        }
        if (this.selectedList === 1 && this.selectedNAsset === 0) {
          deleteTable = gatewayService.currencies.deleteHedge;
        }
        if (this.selectedList === 1 && this.selectedNAsset === 1) {
          deleteTable = gatewayService.commodities.deleteHedge;
        }
        let payload = {
          format: "json",
          selected_company: this.companies[this.selectedCompany].pk_idcompany,
          user_id: this.user.pk_idusers,
          selection: this.selectedList,
          selected_porfolios: { id_portfolios: getPortfolioNumber },
        };
        this.modal_processing_message.showModalLoading = !this
          .modal_processing_message.showModalLoading;
        this.modal_processing_message.messageModal = "Deleting....";
        var delay_state = this;
        deleteTable(payload)
          .then((data) => {
            this.processed_company.onLoadData();
            setTimeout(function() {
              delay_state.modal_processing_message.showModalLoading = !delay_state
                .modal_processing_message.showModalLoading;
              delay_state.modal_process_finished_message.showModalLoading = !delay_state
                .modal_process_finished_message.showModalLoading;
              delay_state.modal_process_finished_message.optionsModal = true;
              delay_state.modal_process_finished_message.messageModal =
                data["successful"];
              delay_state.onAfterDeleteCompany();
              delay_state.onAfterDelete();
            }, 10000);
          })
          .catch((error) => {
            this.modal_processing_message.showModalLoading = !this
              .modal_processing_message.showModalLoading;
            this.modal_process_finished_message.showModalLoading = !this
              .modal_process_finished_message.showModalLoading;
            this.modal_process_finished_message.optionsModal = true;
            this.modal_process_finished_message.messageModal =
              "An error has occurred" + error;
          });
      }
    },
    download() {
      createDataModelTable(this);
    },
  },
  filters: {
    dateFormat: function(val) {
      return !val || +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%d %b %y")(val);
    },
    futuresDateFormat: function(val) {
      return !val || +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%b%y")(val).toUpperCase();
    },
    numberFormat: function(val) {
      return !val ? "-" : format(",")(val);
    },
  },
};
</script>
